import { Icon } from "components/icon/Icon";
import { cn } from "utils";

export interface SelectToggleIconProps {
  /** Whether the item is currently selected */
  selected: boolean;
  /** Unique identifier for the item (used in testId) */
  id: string;
  /** Optional click handler */
  onClick?: () => void;
  /** Additional CSS classes */
  className?: string;
  /** Size of the icon */
  size?: "small" | "medium" | "large";
  /** Whether the icon is disabled */
  disabled?: boolean;
}

export const SelectToggleIcon = ({
  selected,
  id,
  onClick,
  className,
  size = "medium",
  disabled = false,
}: SelectToggleIconProps) => {
  const toggle = disabled ? undefined : onClick;

  // The span is the button because the icon element changes with `selected`,
  // which would drop keyboard focus after each toggle.
  return (
    <span
      className={cn(
        selected ? "text-primary-500" : "text-secondary-400",
        className,
      )}
      role="button"
      aria-label={selected ? "Selected" : "Not selected"}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={toggle}
      onKeyDown={(event) => {
        if (!toggle || (event.key !== "Enter" && event.key !== " ")) return;
        event.preventDefault();
        toggle();
      }}
      style={{ cursor: disabled ? "default" : "pointer" }}
    >
      <Icon
        name={selected ? "circle-check" : "circle-plus"}
        aria-hidden
        size={size}
        data-testid={selected ? `check-icon-${id}` : `add-icon-${id}`}
      />
    </span>
  );
};
